export default __webpack_public_path__ + "static/media/arrow-down-gray.a6f2d8d1.svg";